import type { RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "benefits",
    name: "benefits",
    component: () => import("./pages/BenefitsList.vue"),
    meta: {
      requiresAuth: true,
      requiresStaff: true,
      title: "menu.benefits",
    },
  },
  {
    path: "benefits/nueva",
    name: "benefits-new",
    component: () => import("./pages/BenefitsEdit.vue"),
    meta: {
      requiresAuth: true,
      requiresStaff: true,
      title: "benefits.new",
      forceActiveMenu: "benefits",
    },
  },
  {
    path: "benefits/:id",
    name: "benefits-edit",
    component: () => import("./pages/BenefitsEdit.vue"),
    meta: {
      requiresAuth: true,
      requiresStaff: true,
      title: "benefits.edit",
      forceActiveMenu: "benefits",
    },
  },
  {
    path: "family/benefits",
    name: "family-benefits",
    component: () => import("./pages/FamilyBenefitsPage.vue"),
    meta: {
      requiresAuth: true,
      title: "menu.family_benefits",
    },
  },
];
